<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,

    }
  },
  created() {

  },
  methods: {
    submit_form() {
      this.$emit('curpage');
    },
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">

      <div v-if="item.id" class="bg-white _box-shadow-0-1-4-b-2 border rounded">
        <w-listing-preview :item="item"></w-listing-preview>
      </div>

      <div v-else class="bg-white _box-shadow-0-1-4-b-2 border rounded">
        <div class="">
          <div class="row mx-0">
            <div class="_w-150 p-5 border-right border-light">
              <img :src="formatImage('/fm/revinre-nc/clip art/Real Estate Listings.png')" alt="Listing not found">
            </div>
            <div class="col-12 col-sm p-5">
              <h2 class="h3">Listing not found</h2>
              <p class="m-0 text-muted">Please try refreshing the page.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="row py-5">
        <div class="col-6">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">

        </div>
      </div>
    </form>

  </div>

</template>
